import { useState } from "react";
import { NavLink } from "react-router-dom";
import routeUrls from "../COMPONENTS/navbar/navLink";
import { useAuth } from "../FIREBASE/useAuth";
import "../CSS/stage.scss";

import hero1 from "../images/hero1.webp";
import hero2 from "../images/hero2.webp";
import hero3 from "../images/hero3.webp";

const sections = [
  { label: "Resor",   image: hero1, to: routeUrls.BLOGG    },
  { label: "Träning", image: hero2, to: routeUrls.TRAINING, login: true }, // needs an account: does nothing for visitors
  { label: "Projekt", image: hero3, to: routeUrls.PROJEKT  },
];

export const LandingPageView = () => {
  const [active, setActive] = useState(0);
  const { user, loading } = useAuth();

  return (
    <div className="stage">
      {sections.map(({ image }, i) => (
        <div
          key={i}
          className={`stage__bg${i === active ? " stage__bg--active" : ""}`}
          style={{ backgroundImage: `url(${image})` }}
        />
      ))}

      <div className="stage__overlay" />
      <div className="stage__intro">
        {/* The way in to sign in: the name links to it, without looking like a link */}
        <h1 className="stage__name">
          {loading || user ? "Sebastian Granlund" : <NavLink to={routeUrls.LOGIN} className="stage__name-link">Sebastian Granlund</NavLink>}
        </h1>
      </div>

      <div className="stage__panels">
        {sections.map(({ label, to, login }, i) => (
          <NavLink
            key={label}
            to={to}
            className={`stage__panel${i === active ? " stage__panel--active" : ""}`}
            onMouseEnter={() => setActive(i)}
            onFocus={() => setActive(i)}
            onTouchStart={() => setActive(i)}
            onClick={(e) => { if (login && !user) e.preventDefault(); }}
            style={login && !user ? { cursor: "default" } : undefined}
          >
            <span className="stage__label">{label}</span>
          </NavLink>
        ))}
      </div>
    </div>
  );
};
